import { get } from 'lodash-es';
import { useParams } from 'react-router';

import { PageLabel, PageLabelWrapper } from '@component/header/header.style';
import { useStoreSelector } from '@hook/store/store.hooks';

export const IntegrationName = () => {
  const { serviceId = '' } = useParams();
  const integrations = useStoreSelector((state) => state.connectors.data);

  return (
    <PageLabelWrapper>
      <PageLabel ml={0}>{get(integrations, [serviceId, 'name'])}</PageLabel>
    </PageLabelWrapper>
  );
};
